import { adminAPIService } from './index'

const route = 'shop_the_looks'

export default {
  getList(page = 1, size = 50) {
    const params = { page, size }
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  create(detail) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  updateDetail(detail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  duplicate(id) {
    return adminAPIService({
      url: `${route}/${id}/duplicate`,
      method: 'post',
    })
  },
}
